import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from '@mui/material';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import {SOURCES_DIALOG_STACK_PROPS} from './sourcesDialogStackProps';
import {getSourcesApiBase} from './sourcesApi';

/**
 * Read-only "Add source" reference panel describing the ingestion REST endpoints. Unlike
 * the other Add source dialogs, this one never submits anything — it's documentation, so
 * it only offers a Close action.
 */
const SourcesApiInfoDialog = ({open, onClose, apiBaseUrl}) => {
    const base = apiBaseUrl ?? getSourcesApiBase();
    const fromUrlEndpoint = `${base || ''}/api/data-items/from-url`;
    const fromContentEndpoint = `${base || ''}/api/data-items/from-content`;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            {...SOURCES_DIALOG_STACK_PROPS}
        >
            <DialogTitle>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <CodeRoundedIcon fontSize="small" color="action"/>
                    <span>Add source: API</span>
                </Stack>
            </DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <Typography variant="body2" color="text.secondary">
                        Ingest data items programmatically using the REST API. Both endpoints accept
                        a <code>userId</code> query param (or <code>X-User-Id</code> header) and return
                        the created data item.
                    </Typography>
                    <Box
                        sx={{
                            bgcolor: 'grey.100',
                            border: '1px solid',
                            borderColor: 'grey.200',
                            borderRadius: 1,
                            p: 2,
                            fontFamily: 'monospace',
                            fontSize: 12,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                        }}
                    >
                        {`POST ${fromUrlEndpoint}?userId={userId}
Content-Type: application/json

{ "url": "https://example.com/article",
  "parentFolderId": "optional-folder-id" }

POST ${fromContentEndpoint}?userId={userId}
Content-Type: application/json

{ "htmlContent": "<p>…</p>",
  "plainText": "or plain text",
  "name": "optional title",
  "parentFolderId": "optional-folder-id" }`}
                    </Box>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default React.memo(SourcesApiInfoDialog);
